import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { Sezione } from '../shared/models/sezione.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaSezioniService extends AnagraficaBaseService<Sezione> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaSezioni`);
  }

  get idProperty(): string {
    return 'sezioneId';
  }

  get nameProperty(): string {
    return 'nomeSezione';
  }
}
